import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { AncillariesManagerEditorData } from '../../state/AncillariesManager/EditorData';

const updateAncillariesManagerEditorData: Reducer<AncillariesManagerEditorData> = (
  state: AncillariesManagerEditorData = new AncillariesManagerEditorData(),
  action: Action<ActionType, AncillariesManagerEditorData>
) => {
  switch (action.type) {
    case ActionType.ANCILLARIES_MANAGER_EDITOR_DATA_RESET:
      return new AncillariesManagerEditorData();
    case ActionType.ANCILLARIES_MANAGER_EDITOR_DATA_FETCHED:
      return { ...state, ancillariesManagerEditorData: action.data };
    case ActionType.ANCILLARIES_MANAGER_EDITOR_DATA_COPIED:
      return { ...state, ancillariesManagerEditorData: { ...action.data } };
    case ActionType.ANCILLARIES_MANAGER_EDITOR_DATA_UPDATED:
      return {
        ...state,
        ancillariesManagerEditorData: {
          ...state.ancillariesManagerEditorData,
          ...action.data,
        },
      };
    case ActionType.ANCILLARIES_MANAGER_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.ANCILLARIES_MANAGER_EDITOR_DATA_VALIDATED:
      return { ...state, validation: { ...action.data } };
    case ActionType.ANCILLARIES_MANAGER_EDITOR_SET_BOUND_ITEM:
      return {
        ...state,
        ancillariesManagerEditorData: {
          ...state.ancillariesManagerEditorData,
          ...action.data,
        },
      };
    default:
      return state;
  }
};

export default updateAncillariesManagerEditorData;
